import React, { useState } from 'react';
import Icon from '../general/Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faLock, faSpinner, faLanguage } from '@fortawesome/pro-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';
import { DebounceInput } from 'react-debounce-input';
import useDecks from '../../hooks/useDecks';
import MultilingualDeckThumbnail from './MultilingualDeckThumbnail';

const MultilingualDeckHeader = ({deck}) => {
    console.log("multi: ", deck);
    const [showPrivacyBox, setShowPrivacyBox] = useState(false);
    const [saving, setSaving] = useState(false);
    const togglePrivacyBox = () => {
        setShowPrivacyBox(!showPrivacyBox);
    }

    const {saveChangesToDeck} = useDecks();

    const privacyOptionChanged = async (e) => {
        console.log(e.target.value);
        let newPrivacyOption = e.target.value;
        setSaving(true);
        await saveChangesToDeck({privacy: newPrivacyOption, deckId: deck.id})
        setSaving(false);
    }

    const renameDeckNameOnInput = async (e) => {
        console.log(e.target.value);
        setSaving(true);
        await saveChangesToDeck({deckName: e.target.value.trim(), deckId: deck.id});
        setSaving(false);
    }
    return (
        <div>
            <div className="flex flex-col gap-4">
            <div className="pl-2 flex w-full flex-col gap-4 justify-start place-items-start">
                <div>
                    <MultilingualDeckThumbnail deck={deck} />
                </div>
                <div className="flex flex-row gap-4 justify-start place-items-start">
                    <div className="text-xl relative">
                        {deck !== null &&
                            <>
                                <div onClick={togglePrivacyBox}>
                                    {(deck.privacy === "private") && 
                                        <Icon data-place="left" data-for="card-menu-tooltip"  icon={<FontAwesomeIcon icon={faLock} />} color="charcoal" hover="none" cursor="pointer" /> 
                                    }
                                    {(deck.privacy === "public") && 
                                        <Icon data-place="left" data-for="card-menu-tooltip"  icon={<FontAwesomeIcon icon={faGlobe} />} color="charcoal" hover="none" cursor="pointer" /> 
                                    }
                                </div>
                                {showPrivacyBox &&
                                    <>
                                    <div className="absolute left-0 top-8 bg-white dark:bg-gray-800 rounded-xl w-48 shadow-xl p-5 z-20">
                                        <fieldset>
                                            <div className="flex flex-col gap-3">
                                                {/* Private Option */}
                                                <div>
                                                    <div className="flex flex-row gap-2 font-bold text-base text-gray-700 dark:text-gray-300">
                                                        <input
                                                            onChange={privacyOptionChanged}
                                                            type="radio"
                                                            id="private"
                                                            value="private"
                                                            checked={deck.privacy === "private"}
                                                        />
                                                        <label htmlFor="private">Private</label>
                                                    </div>
                                                    <div className="text-xs text-gray-500 dark:text-gray-400">
                                                        Only you can see this deck.
                                                    </div>
                                                </div>

                                                {/* Public Option */}
                                                <div>
                                                    <div className="flex flex-row gap-2 font-bold text-base text-gray-700 dark:text-gray-300">
                                                        <input
                                                            onChange={privacyOptionChanged}
                                                            type="radio"
                                                            id="public"
                                                            value="public"
                                                            checked={deck.privacy === "public"}
                                                        />
                                                        <label htmlFor="public">Public</label>
                                                    </div>
                                                    <div className="text-xs text-gray-500 dark:text-gray-400">
                                                        Everyone can find and study your deck.
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div onClick={togglePrivacyBox} className="z-10 w-screen h-screen fixed left-0 top-0 ">

                                    </div>
                                    </>
                                }
                            </>
                        }
                        {deck === null &&
                            <>
                                <Skeleton count={1} height={30} />
                            </>
                        }
                    </div>
                    <div className="">
                        <div className="font-bold muted-text text-lg">
                        {deck !== null ? 
                        <DebounceInput
                            className={" text-left dark:text-white hover:underline bg-transparent font-semibold border-none outline-none"}
                            minLength={1}
                            value={deck.name}
                            debounceTimeout={1000}
                            onChange={event => renameDeckNameOnInput(event)} 
                        /> : 
                        <Skeleton count={1} height={30} />}
                        </div>
                        
                    </div>
                    {deck !== null && deck.languages && Array.isArray(deck.languages) && (
                        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                            <FontAwesomeIcon icon={faLanguage} />
                            <span>{deck.languages.filter(lang => lang !== null).length} language{deck.languages.filter(lang => lang !== null).length !== 1 ? 's' : ''}</span>
                        </div>
                    )}
                    <div>
                        {saving && <FontAwesomeIcon icon={faSpinner} spin />}
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default MultilingualDeckHeader;